import React from 'react';
import { X } from 'lucide-react';
interface LegalModalProps {
  type: 'terms' | 'privacy' | null;
  onClose: () => void;
}
const content = {
  terms: {
    title: 'Términos y Condiciones',
    body: <>
        <p className="text-slate-500 text-sm mb-6" data-id="element-32">
          Última actualización: {new Date().getFullYear()}
        </p>

        <h3 className="font-bold text-slate-900 mb-2" data-id="element-33">
          1. Aceptación de los Términos
        </h3>
        <p className="mb-4" data-id="element-34">
          Al adquirir el programa "Disciplina Anti-Flojera", aceptas estos
          términos en su totalidad. Si no estás de acuerdo, por favor no
          realices la compra.
        </p>

        <h3 className="font-bold text-slate-900 mb-2" data-id="element-35">
          2. Descripción del Producto
        </h3>
        <p className="mb-4" data-id="element-36">
          "Disciplina Anti-Flojera" es un programa digital de 21 días diseñado
          para ayudarte a desarrollar hábitos de movimiento y disciplina. El
          acceso es inmediato tras la compra y es de uso personal, no
          transferible.
        </p>

        <h3 className="font-bold text-slate-900 mb-2" data-id="element-37">
          3. Política de Reembolso
        </h3>
        <p className="mb-4" data-id="element-38">
          Ofrecemos una garantía de satisfacción de 30 días. Si no estás
          satisfecha con el programa, puedes solicitar un reembolso completo
          dentro de los 30 días posteriores a la compra, sin preguntas.
        </p>

        <h3 className="font-bold text-slate-900 mb-2" data-id="element-39">
          4. Propiedad Intelectual
        </h3>
        <p className="mb-4" data-id="element-40">
          Todo el contenido del programa — textos, imágenes, audios y materiales
          — es propiedad exclusiva de Disciplina Anti-Flojera. Queda prohibida
          su reproducción, distribución o venta sin autorización escrita.
        </p>

        <h3 className="font-bold text-slate-900 mb-2" data-id="element-41">
          5. Limitación de Responsabilidad
        </h3>
        <p className="mb-4" data-id="element-42">
          Este programa es de carácter educativo e informativo. Los resultados
          pueden variar según cada persona. No sustituye asesoramiento médico o
          profesional de salud.
        </p>

        <h3 className="font-bold text-slate-900 mb-2" data-id="element-43">6. Modificaciones</h3>
        <p className="mb-4" data-id="element-44">
          Nos reservamos el derecho de actualizar estos términos en cualquier
          momento. Los cambios serán efectivos al publicarse en esta página.
        </p>
      </>
  },
  privacy: {
    title: 'Política de Privacidad',
    body: <>
        <p className="text-slate-500 text-sm mb-6" data-id="element-45">
          Última actualización: {new Date().getFullYear()}
        </p>

        <h3 className="font-bold text-slate-900 mb-2" data-id="element-46">
          1. Información que Recopilamos
        </h3>
        <p className="mb-4" data-id="element-47">
          Recopilamos únicamente la información necesaria para procesar tu
          compra: nombre, correo electrónico y datos de pago (procesados de
          forma segura por terceros). No almacenamos datos de tarjetas de
          crédito.
        </p>

        <h3 className="font-bold text-slate-900 mb-2" data-id="element-48">
          2. Uso de la Información
        </h3>
        <p className="mb-4" data-id="element-49">
          Usamos tu información para: entregar el producto digital, enviarte
          comunicaciones relacionadas con tu compra, y ocasionalmente informarte
          sobre actualizaciones o recursos adicionales. Nunca vendemos tu
          información a terceros.
        </p>

        <h3 className="font-bold text-slate-900 mb-2" data-id="element-50">3. Cookies</h3>
        <p className="mb-4" data-id="element-51">
          Este sitio puede utilizar cookies para mejorar tu experiencia de
          navegación y analizar el tráfico. Puedes desactivar las cookies en la
          configuración de tu navegador.
        </p>

        <h3 className="font-bold text-slate-900 mb-2" data-id="element-52">4. Seguridad</h3>
        <p className="mb-4" data-id="element-53">
          Implementamos medidas de seguridad estándar de la industria para
          proteger tu información personal. Sin embargo, ningún método de
          transmisión por Internet es 100% seguro.
        </p>

        <h3 className="font-bold text-slate-900 mb-2" data-id="element-54">5. Tus Derechos</h3>
        <p className="mb-4" data-id="element-55">
          Tienes derecho a acceder, corregir o eliminar tu información personal
          en cualquier momento. Para ejercer estos derechos, puedes comunicarte
          con nosotros a través de los canales disponibles en el sitio.
        </p>

        <h3 className="font-bold text-slate-900 mb-2" data-id="element-56">
          6. Cambios a esta Política
        </h3>
        <p className="mb-4" data-id="element-57">
          Podemos actualizar esta política periódicamente. Te notificaremos
          sobre cambios significativos publicando la nueva política en esta
          página.
        </p>
      </>
  }
};
export function LegalModal({
  type,
  onClose
}: LegalModalProps) {
  if (!type) return null;
  const {
    title,
    body
  } = content[type];
  return <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-58">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-59" />

      {/* Modal */}
      <div className="relative bg-white w-full sm:max-w-2xl sm:rounded-2xl shadow-2xl max-h-[90vh] flex flex-col rounded-t-2xl" data-id="element-60">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-slate-100 flex-shrink-0" data-id="element-61">
          <h2 id="modal-title" className="text-xl font-bold text-slate-900" data-id="element-62">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-slate-100 transition-colors text-slate-500 hover:text-slate-900" aria-label="Cerrar" data-id="element-63">
            <X className="h-5 w-5" data-id="element-64" />
          </button>
        </div>

        {/* Scrollable body */}
        <div className="overflow-y-auto px-6 py-6 text-slate-600 leading-relaxed text-sm" data-id="element-65">
          {body}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-slate-100 flex-shrink-0 text-center" data-id="element-66">
          <button onClick={onClose} className="px-8 py-2.5 bg-slate-900 text-white text-sm font-semibold rounded-full hover:bg-slate-700 transition-colors" data-id="element-67">
            Entendido
          </button>
        </div>
      </div>
    </div>;
}